import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMPANY_LICENSED_STATES_ACTION_TYPE } from '../actions';

const initialState = {};

const licensedStatesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANY_LICENSED_STATES_ACTION_TYPE.GET_STATES:
        return payload || initialState;

      case COMPANY_LICENSED_STATES_ACTION_TYPE.ADD_STATE:
      case COMPANY_LICENSED_STATES_ACTION_TYPE.EDIT_STATE:
        draft[payload.id] = payload;
        break;

      case COMPANY_LICENSED_STATES_ACTION_TYPE.DELETE_STATE:
        delete draft[meta.licenseId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default licensedStatesReducer;
